import axios from 'axios';
import { helperGetApiHeaders, helperConvertApiRoute, axiosErrorHandler } from 'helpers/ApiHelper';

export const FETCH_NEXT_CLIPS_PAGE = 'FETCH_NEXT_CLIPS_PAGE';
export const SET_NEXT_CLIPS_PAGE = 'SET_NEXT_CLIPS_PAGE';
export const SET_FETCHING_STATUS = 'SET_FETCHING_STATUS';

export function setNextClipsPage(url) {
  return {
    type: SET_NEXT_CLIPS_PAGE,
    payload: url,
  };
}

export function setFetchingStatus(value) {
  return {
    type: SET_FETCHING_STATUS,
    payload: value,
  };
}

export function fetchNextClipsPage({ pageType, url, accessToken, deviceId }) {
  let request = {};
  if (pageType && url) {
    const headers = helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId });
    request = axios.get(helperConvertApiRoute(url), headers).catch(axiosErrorHandler);
  }
  return {
    type: FETCH_NEXT_CLIPS_PAGE,
    payload: request,
  };
}
